"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrescriptionCreatedAt = exports.getExoneratingLddSubLabel = exports.isValidPrescriptionPassenger = exports.validPrescriptionPassengerStatuses = exports.otherPassengerPrescriptionSnapshotSelect = exports.passengerPrescriptionSnapshotSelect = exports.getSigningDoctor = exports.canSignForDoctor = exports.isSignatureRightScopeEnough = exports.getPrescriptionSignatureKind = exports.getPrescriptionKindFromPayer = exports.PRESCRIPTION_MAX_CAPACITY = void 0;
var moment_1 = __importDefault(require("@ambler/moment"));
var transport_reasons_1 = require("../transport-reasons");
exports.PRESCRIPTION_MAX_CAPACITY = 99;
// ? Same rule as the type computed when the API creates a prescription
var getPrescriptionKindFromPayer = function (payer) {
    return payer === 'HPTL_A' ? 'ART80' : 'CERFA';
};
exports.getPrescriptionKindFromPayer = getPrescriptionKindFromPayer;
var getPrescriptionSignatureKind = function (type) {
    return type === 'ART80' || type === 'ART80_WITH_SIGNATURE' ? 'ART80' : 'CERFA';
};
exports.getPrescriptionSignatureKind = getPrescriptionSignatureKind;
var isSignatureRightScopeEnough = function (scope, kind) {
    return scope === 'CERFA_AND_ART80' || kind === 'ART80';
};
exports.isSignatureRightScopeEnough = isSignatureRightScopeEnough;
var canSignForDoctor = function (signatureRights, doctorId, kind) { return signatureRights.some(function (right) { return right.doctorId === doctorId && (0, exports.isSignatureRightScopeEnough)(right.scope, kind); }); };
exports.canSignForDoctor = canSignForDoctor;
// ? A doctor without RPPS prescribes under the RPPS and the signature of his linked doctor. Signature rights stay
// ? checked on the prescriber himself: they are copied from the linked doctor (syncNoRppsDoctors).
var getSigningDoctor = function (doctor) { var _a; return (_a = doctor.parentDoctor) !== null && _a !== void 0 ? _a : doctor; };
exports.getSigningDoctor = getSigningDoctor;
exports.passengerPrescriptionSnapshotSelect = {
    id: true,
    createdAt: true,
    status: true,
    direction: true,
    timeReference: true,
    departureTime: true,
    arrivalTime: true,
    requestedVehicle: true,
    specificNeeds: true,
    transportReason: true,
    reason: true,
    payer: true,
    pmtIssuer: true,
    isAccompanied: true,
    timezone: true,
    patient: {
        select: {
            id: true,
            ipp: true,
            gender: true,
            lastname: true,
            firstname: true,
            birthdate: true,
            birthname: true,
            nir: true,
            address: {
                select: {
                    id: true,
                    formattedAddress: true,
                },
            },
        },
    },
    origin: {
        select: {
            id: true,
            mainText: true,
            secondaryText: true,
            mf: {
                select: {
                    id: true,
                    name: true,
                },
            },
            mfu: {
                select: {
                    id: true,
                    needPmtSignature: true,
                    needCerfaImport: true,
                },
            },
            address: {
                select: {
                    id: true,
                    formattedAddress: true,
                },
            },
        },
    },
    originMfd: {
        select: {
            id: true,
            name: true,
            type: true,
        },
    },
    originServiceRaw: true,
    destination: {
        select: {
            id: true,
            mainText: true,
            secondaryText: true,
            mf: {
                select: {
                    id: true,
                    name: true,
                },
            },
            mfu: {
                select: {
                    id: true,
                    needPmtSignature: true,
                    needCerfaImport: true,
                },
            },
            address: {
                select: {
                    id: true,
                    formattedAddress: true,
                },
            },
        },
    },
    destinationMfd: {
        select: {
            id: true,
            name: true,
            type: true,
        },
    },
    destinationServiceRaw: true,
    doctor: {
        select: {
            id: true,
            firstname: true,
            lastname: true,
            rpps: true,
            parentDoctor: {
                select: {
                    id: true,
                    rpps: true,
                },
            },
        },
    },
    mfu: {
        select: {
            id: true,
            needPmtSignature: true,
            needCerfaImport: true,
            mf: {
                select: {
                    id: true,
                    name: true,
                    corporateName: true,
                    finess: true,
                    phone: true,
                    place: {
                        select: {
                            id: true,
                            address: {
                                select: {
                                    id: true,
                                    formattedAddress: true,
                                    city: true,
                                },
                            },
                        },
                    },
                },
            },
            transportReasonCustomizationGroups: {
                select: {
                    id: true,
                    index: true,
                    label: true,
                    transportReasonCustomizations: {
                        select: {
                            id: true,
                            label: true,
                            index: true,
                            reason: true,
                        },
                    },
                },
            },
        },
    },
    trip: {
        select: {
            id: true,
            passengers: {
                select: {
                    id: true,
                },
            },
        },
    },
};
exports.otherPassengerPrescriptionSnapshotSelect = {
    id: true,
    status: true,
    direction: true,
    timeReference: true,
    departureTime: true,
    arrivalTime: true,
    trip: {
        select: {
            id: true,
        },
    },
};
exports.validPrescriptionPassengerStatuses = [
    'CREATED',
    'DELAYED',
    'DISPATCHING',
    'PREBOOKED',
    'BOOKED',
    'REQUESTED',
    'RUNNING',
    'ARRIVED',
    'WAIT_TPTR_CONFIRMATION',
    'WAIT_TC_CONFIRMATION',
    'WAIT_HPTL_CONFIRMATION',
    'CONFIRMED',
    'SUPPORT',
];
var isValidPrescriptionPassenger = function (_a) {
    var status = _a.status;
    return exports.validPrescriptionPassengerStatuses.includes(status);
};
exports.isValidPrescriptionPassenger = isValidPrescriptionPassenger;
var getExoneratingLddSubLabel = function (isExonerating) {
    if (isExonerating != null) {
        return isExonerating ? 'Patient avec une ALD exonérante' : 'Patient avec une ALD non exonérante';
    }
    return '';
};
exports.getExoneratingLddSubLabel = getExoneratingLddSubLabel;
var getPrescriptionCreatedAt = function (_a) {
    var overrides = _a.overrides, prescription = _a.prescription, passengerSnapshot = _a.passengerSnapshot;
    if (overrides === null || overrides === void 0 ? void 0 : overrides.createdAt) {
        return overrides.createdAt;
    }
    var departureTime = passengerSnapshot.departureTime;
    var createdAt = prescription.createdAt;
    if (transport_reasons_1.reasonRules.isUrgentReason(passengerSnapshot.transportReason)) {
        return departureTime;
    }
    if ((0, moment_1.default)(departureTime).isSameOrBefore(createdAt, 'day')) {
        return (0, moment_1.default)(departureTime).subtract(1, 'day').toDate();
    }
    return createdAt;
};
exports.getPrescriptionCreatedAt = getPrescriptionCreatedAt;
//# sourceMappingURL=prescription.js.map